import React, { useState } from "react";
import { Link } from "react-router-dom";

const NavbarMobile = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
    console.log("clicked", isMenuOpen);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: "2% auto",
          // border: "2px solid red",
          padding: "2%",
          width: "90%",
          maxWidth: "90%",
        }}
      >
        <h5
          style={{
            color: "white",
            fontFamily: "Fira Code, monospace",
            fontWeight: "bolder",
          }}
        >
          Mayowa
        </h5>
        <div style={{ textAlign: "right" }}>
          <input
            type="checkbox"
            id="toggle-menu"
            style={{ display: "none" }}
            checked={isMenuOpen}
            onChange={handleMenuToggle}
          />
          <label htmlFor="toggle-menu">
            <span style={{ color: "white" }}>&#9776;</span>
          </label>
          <ul
            style={{
              //   position: "absolute",
              top: "100%",
              left: 0,
              background: "#282C33",
              width: "100%",
              padding: "1rem",
              display: isMenuOpen ? "block" : "none",
            }}
          >
            <li>
              <Link
                to="/"
                style={{ textDecoration: "none", color: "white" }}
                onClick={handleMenuToggle}
              >
                <span style={{ color: "#C778DD" }}>#</span>
                <span>home</span>
              </Link>
            </li>
            <li>
              <Link
                to="/works"
                style={{ textDecoration: "none", color: "white" }}
                onClick={handleMenuToggle}
              >
                <span style={{ color: "#C778DD" }}>#</span>
                <span>works</span>
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                style={{ textDecoration: "none", color: "white" }}
                onClick={handleMenuToggle}
              >
                <span style={{ color: "#C778DD" }}>#</span>
                <span>about me</span>
              </Link>
            </li>
            <li>
              <Link
                to="/contacts"
                style={{ textDecoration: "none", color: "white" }}
                onClick={handleMenuToggle}
              >
                <span style={{ color: "#C778DD" }}>#</span>
                <span>contact</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default NavbarMobile;
